import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  // Lifecycle state for the liquidity pool creation flow.
  // Requested values: 'preparing', 'initializing', 'initialized', 'adding_liquidity', 'active', 'failed'
  poolState: 'preparing',
  poolAddress: null,
  addLiquidityTxSignature: null,
  errorMessage: null,

  // Save endpoint status (best-effort; UI can ignore if needed)
  isSaving: false,
  saveError: null,
};

const liquidityPoolCreationSlice = createSlice({
  name: 'liquidityPoolCreation',
  initialState,
  reducers: {
    setPoolState: (state, action) => {
      state.poolState = action.payload;
    },
    setPoolAddress: (state, action) => {
      state.poolAddress = action.payload;
    },
    setAddLiquidityTxSignature: (state, action) => {
      state.addLiquidityTxSignature = action.payload;
    },
    setPoolErrorMessage: (state, action) => {
      state.errorMessage = action.payload;
    },
    setIsSaving: (state, action) => {
      state.isSaving = action.payload;
      if (action.payload) state.saveError = null;
    },
    setSaveError: (state, action) => {
      state.saveError = action.payload;
    },
    resetLiquidityPoolCreation: (state) => {
      state.poolState = 'preparing';
      state.poolAddress = null;
      state.addLiquidityTxSignature = null;
      state.errorMessage = null;
      state.isSaving = false;
      state.saveError = null;
    },
  },
});

export const {
  setPoolState,
  setPoolAddress,
  setAddLiquidityTxSignature,
  setPoolErrorMessage,
  setIsSaving,
  setSaveError,
  resetLiquidityPoolCreation,
} = liquidityPoolCreationSlice.actions;

export const selectLiquidityPoolCreation = (state) => state.liquidityPoolCreation;
export const selectLiquidityPoolState = (state) => state.liquidityPoolCreation.poolState;
export const selectLiquidityPoolSaveError = (state) => state.liquidityPoolCreation.saveError;

export default liquidityPoolCreationSlice.reducer;

